import React from 'react';

export default function ToastRack(props) {
  return <ul className='toast-rack'>{props.toasts}</ul>;
}
